/* eslint-disable no-param-reassign */
// Utils
import { isObject, joinPaths } from 'ezyvet-fe-helpers';
import { getObjectId } from '../../getObjectId';
import { hasObjectId } from '../../hasObjectId';
/**
 * Adds object paths of the given object or array to the given objectPaths
 *
 * @template T extends (IndexedStore<any> | any[])
 * @param {T} values
 * @param {IndexedStore<string>} objectPaths
 * @param {string} path
 *
 * @return {void}
 */
export var addObjectPaths = function (values, objectPaths, path) {
    if (isObject(values)) {
        // assert(hasObjectId(values), 'Object requires an object id to reference');
        if (hasObjectId(values)) {
            objectPaths[getObjectId(values)] = path;
        }
        var value_1;
        Object.keys(values)
            .forEach(function (key) {
            value_1 = values[key];
            if (typeof value_1 === 'object') {
                addObjectPaths(value_1, objectPaths, joinPaths(path, key.toString()));
            }
        });
    }
    else if (Array.isArray(values)) {
        values.forEach(function (value, index) {
            if (typeof value === 'object') {
                addObjectPaths(value, objectPaths, joinPaths(path, index.toString()));
            }
        });
    }
};
//# sourceMappingURL=addObjectPaths.js.map